'use strict';
const NotificationBuilder = require('./NotificationBuilder');

class CriticalNotificationBuilder extends NotificationBuilder {
    constructor(id, keys) {
        super(id, keys);
        this.type = 'critical';
        this.options = this.constructor.getDefaultOptions();
    }

    static getDefaultOptions() {
        return {
            headerIconClass: 'odf-icon-cross-outline',
            hasCloseIcon: false,
            contentType: 'text',
            hasCTA: true,
            hasRedBox: false,
        };
    }
}

module.exports = CriticalNotificationBuilder;
